import {api} from './api'

export const display = {
	encode: function(parameters) {
		let str = JSON.stringify(parameters)
		if (str.length % 3 == 1) str = str + '  '
		else if (str.length % 3 == 2) str = str + ' '
		str = btoa(str)
		str = str.split("").reverse()

		for (let i = 0; i < str.length; i+=3) {
			let r = Math.random().toString(36).substr(2, 1)
			str.splice(i, 0, r)
		}
		str = str.join("")

		return str
	},
	open: function(parameters) {

		// console.table(parameters)

		window.open(api.path() + 'display.php?p=' + this.encode(parameters))

	}
}
